import {connect} from 'react-redux'

import AnmeldungSchritte from './AnmeldungSchritte'

function mapStateToProps(state) {
  return {
    orientation: state.main.get('viewportWidth') > 1020 ? "horizontal" : "vertical"
  }
}

export default connect(mapStateToProps)(AnmeldungSchritte)



// WEBPACK FOOTER //
// ./src/components/anmeldung-schritte/AnmeldungSchritteComponent.js